<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>카테고리 관리</strong></div>
			<h2 class="h_sub">카테고리 관리</h2>
		</div>

    <CategoryManageListForm/>
  </div>
</template>

<script>
import CategoryManageListForm from '@/components/admin/etc/CategoryManageListForm.vue';

export default {
  components: {
    CategoryManageListForm
  }
}
</script>
<style lang="">
    
</style>